import gql from 'graphql-tag';

export default gql`
  query Refresh {
    refresh {
      token
      enabledStats
      user {
        id
        name
        type
        theater {
          plan
          id
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/Refresh.js